import cxcService from '@/services/cuentasPorCobrar.service'

const state = {
  planes: [],
  planActual: null,
  loading: false,
  soloConSaldo: true
}

const getters = {
  allPlanes: state => state.planes,
  planActual: state => state.planActual,
  loading: state => state.loading,
  soloConSaldo: state => state.soloConSaldo
}

const mutations = {
  SET_PLANES (state, planes) { state.planes = planes },
  SET_PLAN_ACTUAL (state, plan) { state.planActual = plan },
  SET_LOADING (state, v) { state.loading = v },
  SET_SOLO_CON_SALDO (state, v) { state.soloConSaldo = v },
  UPSERT_PLAN (state, plan) {
    const i = state.planes.findIndex(p => p.id === plan.id)
    if (i !== -1) state.planes.splice(i, 1, plan)
    else state.planes.unshift(plan)
  }
}

const actions = {
  async fetchPlanes ({ commit, state }) {
    commit('SET_LOADING', true)
    try {
      const data = await cxcService.getAll({ soloConSaldo: state.soloConSaldo })
      commit('SET_PLANES', data || [])
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchPlan ({ commit }, planId) {
    commit('SET_LOADING', true)
    try {
      const plan = await cxcService.getById(planId)
      commit('SET_PLAN_ACTUAL', plan)
      return plan
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async pagarCuota ({ commit }, { planId, numero, dto }) {
    const plan = await cxcService.pagarCuota(planId, numero, dto)
    commit('SET_PLAN_ACTUAL', plan)
    commit('UPSERT_PLAN', plan)
    return plan
  },

  async refinanciar ({ commit }, { planId, dto }) {
    const plan = await cxcService.refinanciar(planId, dto)
    commit('SET_PLAN_ACTUAL', plan)
    commit('UPSERT_PLAN', plan)
    return plan
  }
}

export default { namespaced: true, state, getters, mutations, actions }
